import { render, staticRenderFns } from "./FieldListElement.vue?vue&type=template&id=22bb7d69&scoped=true&lang=html"
import script from "./FieldListElement.vue?vue&type=script&lang=js"
export * from "./FieldListElement.vue?vue&type=script&lang=js"
import style0 from "./FieldListElement.vue?vue&type=style&index=0&id=22bb7d69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb7d69",
  null
  
)

export default component.exports